import React, { useEffect } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { Button, SplitBackgroundLayout } from '../components'
import { Card } from '../components/ui/Card'
import { useInternationalSignupsEnabled } from '../contexts'
import { LoginMetaProps } from '../data/types'
import { useAuth } from './auth'


type Props = {
    meta: LoginMetaProps
    className?: string
}

export const Login = (props: Props) => {
    const { meta, className = '' } = props
    const { login, isAuthenticated, authError, clearAuthError } = useAuth()
    const navigate = useNavigate()
    const { value: internationalSignupsEnabled, loading: settingsLoading } = useInternationalSignupsEnabled()
    const location = useLocation()
    const from = (location.state as any)?.from || '/'

    useEffect(() => {
        if (isAuthenticated) {
            navigate(from, { replace: true })
        }
    }, [isAuthenticated, navigate, from])

    // Clear auth error when user navigates away
    useEffect(() => {
        return () => { clearAuthError() }
    }, [clearAuthError])

    if (settingsLoading) {
        return null
    }

    return (
        <SplitBackgroundLayout className={className}>
            <Card className="rounded-xl p-4 flex flex-col items-center justify-center px-4 w-full max-w-sm space-y-4 shadow-lg">
                {authError && (
                    <div className="w-full bg-warn-500/10 border border-warn-500 text-warn-700 dark:text-warn-400 px-4 py-3 rounded-lg">
                        <p className="font-bold text-lg mb-1">{meta.pendingApprovalTitle}</p>
                        <p className="text-sm">{authError}</p>
                    </div>
                )}
                <Button onClick={() => login(navigate)} className="w-full">
                    {meta.ukResidentLoginButton}
                </Button>
                {internationalSignupsEnabled && (
                    <Button onClick={() => navigate('/international/login')} className="w-full" variant="outline">
                        {meta.internationalVisitorLoginButton}
                    </Button>
                )}
                <Link to="/checkin-login" className="text-xs text-gray-500 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 underline underline-offset-2">
                    {meta.checkInLoginLink}
                </Link>
                <Link to="https://iv.iiuk.org/vms-faq/" target="_blank" className="text-sm text-primary-600 font-bold underline mt-2">
                    FAQ
                </Link>
                <div className="text-xs text-center text-gray-600 dark:text-gray-300 mt-2 whitespace-pre-wrap">
                    {meta.helpText && (typeof meta.helpText === 'function' ? meta.helpText() : meta.helpText)}
                </div>
            </Card>
        </SplitBackgroundLayout>
    )
}
